import { render, staticRenderFns } from "./ExamManagement.vue?vue&type=template&id=4adeff57&scoped=true"
import script from "./ExamManagement.vue?vue&type=script&lang=js"
export * from "./ExamManagement.vue?vue&type=script&lang=js"
import style0 from "./ExamManagement.vue?vue&type=style&index=0&id=4adeff57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adeff57",
  null
  
)

export default component.exports